import { addPlayNumber } from '@api/longVideo';
import videojs from 'video.js';
import { decryptString } from '@utils/common';
import siteConfig from '@/siteConfig';

export const globalMixins = {
  data () {
    return {
      SITE_CHANNEL: SITE_CHANNEL,
      siteConfig
    };
  },
  computed: {
    ...mapState('publicStore', ['afterChangeLangMethods', 'isApp', 'isWebClip']),
    ...mapState('user', ['token']),
    lang () {
      return this.$i18n.locale;
    },
    isZh () {
      return this.$i18n.locale === 'TC';
    },
    isVn () {
      return this.$i18n.locale === 'VNM';
    },
    isEN () {
      return this.$i18n.locale === 'USA';
    }
  },
  methods: {
    ...mapMutations('publicStore', ['setAfterChangeLangMethods']),
    back (fromRoute) {
      const _fromRoute = fromRoute || localStorage.getItem('fromRoute');
      if (_fromRoute) {
        this.$router.push(_fromRoute);
      } else {
        window.history.go(-1);
      }
      localStorage.removeItem('fromRoute');
    },
    doCopy (text) {
      this.$copyText(text).then(() => {
        this.$toast.succeed(this.$t('copySuccess'));
      }, () => {
        this.$toast.failed(this.$t('copySuccess'));
      });
    },
    goCustomer () {
      this.$router.push('/customerService');
    },
    initAfterChangeLang (methods) {
      //  绑定切换语言后要调用的接口
      this.$bus.$off('afterChangeLanguage');
      this.setAfterChangeLangMethods(methods);
      this.$bus.$on('afterChangeLanguage', ({ isOnlyHomeShortVideo = false, isOnlyHotShortVideo = false }) => {
        if (isOnlyHomeShortVideo) {
          // 首页短视频刷新
          this.afterChangeLangMethods.forEach(method => {
            if (['getShortVideo'].includes(method.name.split(' ')[1])) {
              this.$bus.$emit('setVideoList');
              method();
            }
          });
        } else if (isOnlyHotShortVideo) {
          // 热门短视频刷新
          this.afterChangeLangMethods.forEach(method => {
            if (['getHotShortVideo'].includes(method.name.split(' ')[1])) {
              this.$bus.$emit('setHotVideoList');
              method();
            }
          });
        } else {
          // 切换地区或者切换语言后
          this.afterChangeLangMethods.forEach(method => {
            const methodName = method.name.split(' ')[1];
            const isHomeShortVideo = ['getShortVideo'].includes(methodName);
            const isHotShortVideo = ['getHotShortVideo'].includes(methodName);

            if (isHomeShortVideo) {
              this.$bus.$emit('setVideoList');
            }
            if (isHotShortVideo) {
              this.$bus.$emit('setHotVideoList');
            }
            method();
          });
        }
      });
    },
    jumpPath ({ url, thirdPage = false, isNew = false }) {
      // thirdPage 路由iframe潜逃, isNew是否是winddom.open

      // eslint-disable-next-line no-undef
      // plus.webview.postMessageToUniNView({
      //   type: '哈哈哈',
      //   args: {
      //     arg1: '123'
      //   }
      // }, '__uniapp__service');

      // 调用套壳app的函数， 唤醒手机浏览器去打开链接, 避免在webview中打开无法返回页面，或者打不开的问题
      // eslint-disable-next-line no-undef
      // uni.postMessage({ data: { action: 'openBrowser', data: url } });
      if (this.isApp) {
        // eslint-disable-next-line no-undef
        // uni.postMessage({ data: { action: 'openBrowser', data: url } });

        // eslint-disable-next-line no-undef
        plus.webview.postMessageToUniNView({
          action: 'openBrowser',
          params: {
            url
          }
        }, '__uniapp__service');
      } else if (isNew) {
        window.open(url);
      } else if (thirdPage) {
        localStorage.setItem('fromRoute', this.$route.fullPath);
        localStorage.setItem('thirdPageSrc', url);
        this.$router.push('/thirdPage');
      } else {
        window.location.href = url;
      }
    }
  }
};

export const video = {
  data () {
    return {
      player: null,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.25, 1.5, 2.0, 3.0],
        // pictureInPictureToggle: true,
        autoplay: false,
        controls: true,
        preload: 'auto',
        // // fluid: true, // 自适应宽高
        muted: false, // 是否静音
        loop: true,
        controlBar: { // 设置控制条组件
          //   // 设置控制条里面组件的相关属性及显示与否
          //   // currentTimeDisplay: true,
          //   // timeDivider: true,
          //   // durationDisplay: true,
          //   // remainingTimeDisplay: true,
          //   // playbackRateMenuButton: true,
          //   // volumePanel: {
          //   //   inline: false
          //   // },
          //   /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
          children: [
            { name: 'playToggle' }, // 播放按钮
            { name: 'currentTimeDisplay' }, // 当前已播放时间
            { name: 'progressControl' }, // 播放进度条
            { name: 'durationDisplay' }, // 总时间
            { // 倍数播放
              name: 'playbackRateMenuButton'
            },
            {
              name: 'volumePanel', // 音量控制
              inline: false // 不使用水平方式
            },
            { name: 'pictureInPictureToggle' }, // 画中画
            { name: 'FullscreenToggle' } // 全屏
          ]
        }
      }
    };
  },
  mounted () {
    this.player = videojs(this.$refs.videoPlayer, this.playerOptions, () => {
      // this.player.log('onPlayerReady', this);
    });
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    ...mapActions('publicStore', ['addShortTask']),
    playVideo (url, vid, type = 'application/x-mpegURL', isBtn = false) {
      const data = {
        src: url,
        type
        // type: 'application/x-mpegURL'
      };
      // console.log('url', url);
      this.player.pause();
      this.player.src(data);
      this.player.load(data);
      if (isBtn && !this.player.getChild('ControlBar').getChild('RewindButton')) {
        this.getRewindButton(this.player);
        this.getForwardButton(this.player);
        this.player.getChild('ControlBar').addChild('RewindButton', {}, 0);
        this.player.getChild('ControlBar').addChild('ForwardButton', {}, 2);
      }
      // 动态切换poster
      // this.player.posterImage.setSrc('xxx.jpg');
      // this.player.play();
      if (this.token) {
        addPlayNumber({ vid });
        // this.addShortTask({ vid, type: 2 });
      }
    },
    getRewindButton (player) {
      const RewindButton = videojs.getComponent('Button');
      const rewindButton = videojs.extend(RewindButton, {
        constructor: function () {
          RewindButton.apply(this, arguments);
          this.controlText('后退 10 秒');
          this.addClass('vjs-rewind-button');
        },
        handleClick: function () {
          const currentTime = player.currentTime();
          player.currentTime(Math.max(0, currentTime - 10));
        }
      });
      videojs.registerComponent('RewindButton', rewindButton);
    },
    getForwardButton (player) {
      const ForwardButton = videojs.getComponent('Button');
      const forwardButton = videojs.extend(ForwardButton, {
        constructor: function () {
          ForwardButton.apply(this, arguments);
          this.controlText('快进 10 秒');
          this.addClass('vjs-forward-button');
        },
        handleClick: function () {
          const duration = player.duration();
          const currentTime = player.currentTime();
          player.currentTime(Math.min(duration, currentTime + 10));
        }
      });
      videojs.registerComponent('ForwardButton', forwardButton);
    }
  }
};

export const loginRegister = {
  methods: {
    goPath (path) {
      localStorage.setItem('fromRoute', this.$route.fullPath);
      this.$router.push(path);
    }
  }
};
export const textRenderFun = {
  methods: {
    textRender (format, val1, val2, val3) {
      if (format === 'yyyy') return val1 + this.$t('cYear');
      if (format === 'MM') {
        if (this.$i18n.locale === 'TC') {
          return val2 + this.$t('month');
        }
        return this.$t('cMonth')[val2];
      }
      if (format === 'dd') return val3 + this.$t('cDay');
    }
  }
};

export const decryptedMixin = {
  methods: {
    decrypted (url) {
      let newUrl = url;

      // let newUrl = item.m3u8_url || item.url || item.video;

      // if (item.is_encrypt === 1 || item.is_encrypt === true || !newUrl.includes('http')) {
      //   newUrl = decryptString(newUrl, 'utf-8');
      // }

      if (newUrl && !newUrl.includes('http')) {
        newUrl = decryptString(newUrl, 'utf-8');
      }
      return newUrl;
    }
  }
};
